import { ReactNode } from "react";

const services: { title: string; text: string; icon: ReactNode }[] = [
  {
    title: "AI & RAG systems",
    text: "Assistants and agents grounded on your own data, with sources you can verify.",
    icon: (
      <>
        <path d="M12 3l1.8 4.6L18 9l-4.2 1.4L12 15l-1.8-4.6L6 9l4.2-1.4z" />
        <path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z" />
      </>
    ),
  },
  {
    title: "Web & mobile apps",
    text: "Product design and development, from MVP to apps used by thousands.",
    icon: (
      <>
        <rect x="3" y="4" width="13" height="10" rx="2" />
        <rect x="15" y="9" width="6" height="11" rx="1.5" />
        <path d="M7 18h6" />
      </>
    ),
  },
  {
    title: "Data & analytics",
    text: "Pipelines, statistical models and dashboards that turn data into decisions.",
    icon: <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />,
  },
  {
    title: "IoT & integrations",
    text: "Devices, printers and legacy systems connected and kept in sync.",
    icon: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
      </>
    ),
  },
];

export function ServicesSection() {
  return (
    <section className="services" id="services">
      <div className="section-header">
        <div>
          <span className="eyebrow">02 — WHAT WE DO</span>
          <h2>
            Rigor of mathematics,
            <br />
            speed of a small team.
          </h2>
        </div>
      </div>
      <div className="grid4">
        {services.map((s) => (
          <div className="service-card" key={s.title}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              {s.icon}
            </svg>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
